/* eslint-disable no-console */
import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;
const apiUrl = process.env.REACT_APP_SCODIX_API_URL || baseUrl || '';

const joinUrl = (base: string, path: string) => `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;

const fileUpload = {
   uploadFile: async (file: File) => {
      if (!apiUrl) {
         console.warn('REACT_APP_SCODIX_API_URL/REACT_APP_API_URL is undefined');
      }
      const url = joinUrl(apiUrl, 'visualization/prospects/upload');
      const form = new FormData();
      form.append('file', file);
      const response = await axios.post(url, form, {
         headers: {
            Authorization: 'Bearer my_secure_token_123',
            'Content-Type': 'multipart/form-data',
         },
      });
      return response.data as { uploadUrl?: string; url?: string; [k: string]: any };
   },
   getUploadUrl: async (file: string) => {
      if (!apiUrl) 
      {
         console.warn('REACT_APP_SCODIX_API_URL/REACT_APP_API_URL is undefined');
      }
      const url = joinUrl(apiUrl, 'visualization/prospects/upload');
      const accessToken = sessionStorage.getItem('accessToken');
      const response = await axios.post(
         url,
         {},
         {
            headers: {
               Authorization: `Bearer ${accessToken}`,
            },
            params: { file },
         },
      );
      return response.data as { uploadUrl?: string; url?: string; [k: string]: any };
   },
};

export default fileUpload;
